import { useEffect, useState } from "react"

export const LOADING_TIPS = [
  ["admin.ai_chat_bot_tip_ram", "Downloading more RAM..."],
  ["admin.ai_chat_bot_tip_isp", "Tip your internet provider..."],
  ["admin.ai_chat_bot_tip_splines", "Reticulating splines..."],
  ["admin.ai_chat_bot_tip_hamsters", "Convincing the hamsters to run faster..."],
  ["admin.ai_chat_bot_tip_multiverse", "Searching every hotel in the multiverse..."],
  ["admin.ai_chat_bot_tip_wifi", "Untangling the WiFi cables..."],
  ["admin.ai_chat_bot_tip_almost", "Almost there, promise..."],
  ["admin.ai_chat_bot_tip_camels", "Negotiating with a camel for a better rate..."],
]

const useLoadingTip = (isActive) => {
  const [tip, setTip] = useState(null)

  useEffect(() => {
    if (!isActive) {
      setTip(null)
      return
    }

    const timer = setTimeout(() => {
      setTip(LOADING_TIPS[Math.floor(Math.random() * LOADING_TIPS.length)])
    }, 4000)
    return () => clearTimeout(timer)
  }, [isActive])

  return tip
}

export default useLoadingTip
